import React from 'react';
import { Link } from 'react-router-dom';

export function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8">
            <Link 
              to="/"
              className="text-primary hover:text-primary/90 transition-colors"
            >
              ← Вярнуцца на галоўную
            </Link>
          </div>
          
          <h1 className="text-3xl font-bold mb-8">Палітыка прыватнасці</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="mb-6">
              Мы паважаем вашу прыватнасць і імкнемся абараніць вашы персанальныя дадзеныя. 
              Гэтая палітыка прыватнасці тлумачыць, як мы збіраем, выкарыстоўваем і абараняем 
              вашу інфармацыю пры выкарыстанні нашага сэрвісу.
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">
              Збор інфармацыі
            </h2>
            <p className="mb-6">
              Мы збіраем наступную інфармацыю:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Email адрас (пры рэгістрацыі)</li>
              <li>Геалакацыя (па жаданні, для паказу бліжэйшых месцаў)</li>
              <li>Інфармацыя пра дададзеныя вамі лакацыі</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-8 mb-4">
              Выкарыстанне інфармацыі
            </h2>
            <p className="mb-6">
              Мы выкарыстоўваем сабраную інфармацыю для:
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Забеспячэння працы сэрвісу</li>
              <li>Паляпшэння функцыянальнасці</li>
              <li>Адпраўкі важных абнаўленняў</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-8 mb-4">
              Абарона дадзеных
            </h2>
            <p className="mb-6">
              Мы выкарыстоўваем сучасныя меры бяспекі для абароны вашых дадзеных, 
              уключаючы шыфраванне і бяспечнае захоўванне.
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">
              Змены ў палітыцы
            </h2>
            <p className="mb-6">
              Мы можам абнаўляць гэтую палітыку прыватнасці. Усе змены будуць 
              апублікаваны на гэтай старонцы.
            </p>

            <h2 className="text-2xl font-semibold mt-8 mb-4">
              Кантакты
            </h2>
            <p>
              Калі ў вас ёсць пытанні наконт нашай палітыкі прыватнасці, калі ласка, 
              звяжыцеся з намі праз форму зваротнай сувязі на галоўнай старонцы.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}